import { getBrandContext } from '../config/brand'

export function isMenuItemVisibleForBrand(item, context = getBrandContext()) {
  const hiddenForBrands = Array.isArray(item?.hiddenForBrands) ? item.hiddenForBrands : []
  return !hiddenForBrands.includes(context.activeBrand)
}
